// Classroom service — fetches school classrooms and roster data for the teacher view.
import { apiGet } from './apiClient';

export interface ClassroomSummary {
  id: string;
  name: string;
  subject: string | null;
  gradeLevel: string | null;
  period: string | null;
  isActive: boolean;
  studentCount: number;
  activeAlerts: number;
  criticalAlerts: number;
}

export interface RosterStudent {
  student: {
    id: string;
    user: {
      name: string;
      email: string;
    };
  };
}

export const classroomService = {
  async getSchoolClassrooms(): Promise<ClassroomSummary[]> {
    const response = await apiGet<{ success: boolean; classrooms: ClassroomSummary[] }>('/classrooms');
    return response.classrooms;
  },

  async getClassroomRoster(classroomId: string): Promise<RosterStudent[]> {
    const response = await apiGet<{ success: boolean; students: RosterStudent[] }>(`/classrooms/${classroomId}/roster`);
    return response.students;
  },
};
